import {
    FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE,
    FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_DONE,
    FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_START,
    FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER,
    FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER_DONE,
    REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE,
    REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE_DONE
} from './ActionTypes';

import 'utils/userSocialProfileImage/profileImageTypeDefs';

/** actions */
export const fetchUserSocialProfileImageViewer = (evictCache = false) => {
    return {
        type: FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER,
        meta: {
            cacheTime: evictCache ? null : 12000
        }
    };
};

export const fetchUserSocialProfileImageViewerDone = (data, error = false) => {
    return {
        type: FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER_DONE,
        data,
        error
    };
};

/**
 * fetch multiple user social profile image (including frames)
 * @param {number[]|string[]} userIds
 * @param {boolean} [clearCache] force clear cache (cache time: 1 min)
 * @returns
 */
export const fetchMultipleUserSocialProfileImage = (userIds, clearCache = false) => {
    return {
        type: FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE,
        userIds,
        clearCache
    };
};

/**
 * update reducer fetching list (to reduce duplicated user id fetching)
 * @param {number[]|string[]} userIds
 * @returns
 */
export const fetchMultipleUserSocialProfileImageStart = (userIds) => {
    return {
        type: FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_START,
        userIds
    };
};

/**
 * @param {Object} payload
 * @param {{[profileId: string]: SimplePublicSocialProfileV2DTO } | null} [payload.data]
 * @param {boolean} [payload.error]
 * @returns
 */
export const fetchMultipleUserSocialProfileImageDone = ({ data, error = false }) => {
    return {
        type: FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_DONE,
        error,
        data
    };
};

/**
 * @param {Object} payload
 * @param {string} payload.displayName
 * @param {boolean} payload.hasSubscribed
 * @param {(error: boolean) => any} [payload.callback]
 */
export const removeViewerSocialProfileImage = ({ displayName, hasSubscribed, callback = () => {} }) => {
    return {
        type: REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE,
        displayName,
        hasSubscribed,
        callback
    };
};

export const removeViewerSocialProfileImageDone = () => {
    return {
        type: REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE_DONE
    };
};
